import React from 'react'
import Index from './components/Index'
const App = () => {
  
  return (<>
    <Index/>
  </>
  )
}

export default App